export const layoutComponent = {
  key: 'layoutComponent',
  name: 'Layout Component',
  siteIdentifier: 'sso',

  logoImageAlt: '{brandName} Logo',
};
